// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-list .body-scroll {
  display: block;
  max-height: 550px;
  overflow-y: auto;
  margin-top: -25px;
}

.profile-list thead {
  display: table;
  width: 100%;
}

.profile-list tr {
  display: table;
  width: 100%;
  box-sizing: border-box;
  margin-top: -15px;
}
/*.profile-list tr:hover{*/
/*  background: #737373 !important;*/
/*}*/
/*.profile-list .white-area:hover {*/
/*  background: #737373 !important;*/
/*  !*box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);*!*/
/*}*/

.profile-list tr:hover .white-area{
  background: #eaeaea !important;
  /*box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);*/
}


.profile-list table {
  border-collapse: separate;
  border-spacing: 0 18px;
}

.wm {
  max-width: 197px;
}

.w-403 {
  max-width: 403px;
  min-width: 160px;
}

.w-750 {
  width: 750px;
  min-width: 506px;
}

.w-160 {
  min-width: 160px;
  max-width: 403px;
}

.profile-list table thead tr th {
  font-weight: 400;
  font-size: 18px;
  color: #0f062b;
  white-space: nowrap;
}

.profile-list .table > :not(:last-child) > :last-child > * {
  border-bottom: none;
  border-top: none;
}

.profile-list .table > :not(caption) > * > * {
  border-bottom: none;
}

.profile-list .table tbody tr .white-area {
  background-color: #fff;
  vertical-align: middle;
  padding: 20px;
  border-color: #f8f8f8;
  border-style: solid;
  border-width: 1px 0 1px 0;
}

.profile-list .table tbody tr .white-area:first-child {
  border-radius: 8px 0 0 8px;
  border-color: #f8f8f8;
  border-style: solid;
  border-width: 1px 0 0 1px;
}

.profile-list .table tbody tr .white-area:last-child {
  border-radius: 0 8px 8px 0;
  border-color: #f8f8f8;
  border-style: solid;
  border-width: 0 1px 1px 0;
}

.profile-list .table tbody tr .white-area .gap-2 {
  gap: 0.5rem !important;
}

.profile-list .table tbody tr .white-area .area-img {
  width: 213px;
  height: 135px;
  border-radius: 8px;
  flex-shrink: 0;
}

.profile-list .table tbody tr .white-area .text-area {
  width: 320px;
}

.profile-list .table tbody tr .white-area .text-area h5 {
  font-weight: 400;
  font-size: 16px;
  color: #0f062b;
}

.profile-list .table tbody tr .white-area .text-area p {
  font-weight: 400;
  font-size: 14px;
  color: #818083;
  margin-bottom: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-list .table tbody tr .white-area .text-purple {
  font-weight: 400;
  font-size: 16px;
  color: #6c2fbb;
}

.profile-list .table tbody tr .white-area .purple-dark {
  font-weight: 400;
  font-size: 16px;
  color: #312545;
}

.groupName {
  font-size: 20px;
  padding-block: 20px;
  margin-bottom: 0;
}


.group-detail{
  padding-block: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.group-detail img{
  object-fit: contain;
  background: #ededed;
  border-radius: 10px;
  padding: 3px;
}


@media (max-width: 1500px) {
  .w-750 {
    width: 640px;
  }

  .profile-list table thead tr th {
    font-size: 18px;
  }
}

@media (max-width: 1300px) {
  .w-630 {
    width: 630px;
  }

  .w-160 {
    min-width: 183px;
    max-width: 403px;
  }

  .profile-list table thead tr th {
    font-size: 17px;
  }

  .profile-list .body-scroll {
    margin-top: -35px;
  }
}
@media (max-width: 420px) {
  .profile-list .table tbody tr .white-area .area-img{
    width: 120px;
    height: 90px;
  }
  .profile-list .body-scroll {
    padding-bottom: 100px;
    overflow-x: hidden;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/group/group-list/group-list.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;AACA,0BAA0B;AAC1B,oCAAoC;AACpC,IAAI;AACJ,oCAAoC;AACpC,oCAAoC;AACpC,gDAAgD;AAChD,IAAI;;AAEJ;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;;;AAGA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;;AAGA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;AACF","sourcesContent":[".profile-list .body-scroll {\n  display: block;\n  max-height: 550px;\n  overflow-y: auto;\n  margin-top: -25px;\n}\n\n.profile-list thead {\n  display: table;\n  width: 100%;\n}\n\n.profile-list tr {\n  display: table;\n  width: 100%;\n  box-sizing: border-box;\n  margin-top: -15px;\n}\n/*.profile-list tr:hover{*/\n/*  background: #737373 !important;*/\n/*}*/\n/*.profile-list .white-area:hover {*/\n/*  background: #737373 !important;*/\n/*  !*box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);*!*/\n/*}*/\n\n.profile-list tr:hover .white-area{\n  background: #eaeaea !important;\n  /*box-shadow: 0 0 2px 0 rgb(0 0 0 / 50%);*/\n}\n\n\n.profile-list table {\n  border-collapse: separate;\n  border-spacing: 0 18px;\n}\n\n.wm {\n  max-width: 197px;\n}\n\n.w-403 {\n  max-width: 403px;\n  min-width: 160px;\n}\n\n.w-750 {\n  width: 750px;\n  min-width: 506px;\n}\n\n.w-160 {\n  min-width: 160px;\n  max-width: 403px;\n}\n\n.profile-list table thead tr th {\n  font-weight: 400;\n  font-size: 18px;\n  color: #0f062b;\n  white-space: nowrap;\n}\n\n.profile-list .table > :not(:last-child) > :last-child > * {\n  border-bottom: none;\n  border-top: none;\n}\n\n.profile-list .table > :not(caption) > * > * {\n  border-bottom: none;\n}\n\n.profile-list .table tbody tr .white-area {\n  background-color: #fff;\n  vertical-align: middle;\n  padding: 20px;\n  border-color: #f8f8f8;\n  border-style: solid;\n  border-width: 1px 0 1px 0;\n}\n\n.profile-list .table tbody tr .white-area:first-child {\n  border-radius: 8px 0 0 8px;\n  border-color: #f8f8f8;\n  border-style: solid;\n  border-width: 1px 0 0 1px;\n}\n\n.profile-list .table tbody tr .white-area:last-child {\n  border-radius: 0 8px 8px 0;\n  border-color: #f8f8f8;\n  border-style: solid;\n  border-width: 0 1px 1px 0;\n}\n\n.profile-list .table tbody tr .white-area .gap-2 {\n  gap: 0.5rem !important;\n}\n\n.profile-list .table tbody tr .white-area .area-img {\n  width: 213px;\n  height: 135px;\n  border-radius: 8px;\n  flex-shrink: 0;\n}\n\n.profile-list .table tbody tr .white-area .text-area {\n  width: 320px;\n}\n\n.profile-list .table tbody tr .white-area .text-area h5 {\n  font-weight: 400;\n  font-size: 16px;\n  color: #0f062b;\n}\n\n.profile-list .table tbody tr .white-area .text-area p {\n  font-weight: 400;\n  font-size: 14px;\n  color: #818083;\n  margin-bottom: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.profile-list .table tbody tr .white-area .text-purple {\n  font-weight: 400;\n  font-size: 16px;\n  color: #6c2fbb;\n}\n\n.profile-list .table tbody tr .white-area .purple-dark {\n  font-weight: 400;\n  font-size: 16px;\n  color: #312545;\n}\n\n.groupName {\n  font-size: 20px;\n  padding-block: 20px;\n  margin-bottom: 0;\n}\n\n\n.group-detail{\n  padding-block: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n}\n.group-detail img{\n  object-fit: contain;\n  background: #ededed;\n  border-radius: 10px;\n  padding: 3px;\n}\n\n\n@media (max-width: 1500px) {\n  .w-750 {\n    width: 640px;\n  }\n\n  .profile-list table thead tr th {\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 1300px) {\n  .w-630 {\n    width: 630px;\n  }\n\n  .w-160 {\n    min-width: 183px;\n    max-width: 403px;\n  }\n\n  .profile-list table thead tr th {\n    font-size: 17px;\n  }\n\n  .profile-list .body-scroll {\n    margin-top: -35px;\n  }\n}\n@media (max-width: 420px) {\n  .profile-list .table tbody tr .white-area .area-img{\n    width: 120px;\n    height: 90px;\n  }\n  .profile-list .body-scroll {\n    padding-bottom: 100px;\n    overflow-x: hidden;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
